<template>
  <div class="course-detail">
    <CommonTable
      ref="course-detail-table"
      tableType="课程详情"
      :keys="keys"
      :list="list"
      :count="count"
      :border="true"
      @changePagingParams="changePagingParams"
      @download="download"
      @onSortChange="onSortChange"
    >
      <template v-slot:table-filter>
        <div class="slot-box">
          <div class="slot-box-left">
            <SelectCom
              placeholder="请选择上课状态"
              v-model="filterParams.status"
              :options="statusList"
            />
          </div>
          <div class="slot-box-right">
            <SelectRemoteCom
              placeholder="输入学校或机构名称"
              :clearable="true"
              :getListFunc="getSchoolListFunc"
              v-model="filterParams.orgId"
              :filterName="filterParams.orgName"
            />
          </div>
        </div>
      </template>
    </CommonTable>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'
import { exportXlsx } from '@/utils/common'
import CommonTable from '../common/CommonTable'
import SelectCom from '../common/SelectCom'
import SelectRemoteCom from '../common/SelectRemoteCom'

export default {
  name: 'CourseDetail',
  components: {
    CommonTable,
    SelectCom,
    // CommonInput,
    SelectRemoteCom,
  },
  data() {
    return {
      filterParams: {
        status: '',
        name: '',
      },
      statusList: [
        {
          value: 0,
          label: '待上课',
        },
        {
          value: 1,
          label: '已上课',
        },
        {
          value: 2,
          label: '缺课',
        },
        {
          value: 3,
          label: '正在上课',
        },
      ],
      keys: [
        {
          prop: 'school',
          label: '学校机构',
          component: 'org',
        },
        {
          prop: 'class',
          label: '班级',
        },
        {
          prop: 'area',
          label: '所属区域',
        },
        {
          prop: 'course',
          label: '课程名称',
        },
        {
          prop: 'teacher',
          label: '任课老师',
        },
        {
          prop: 'status',
          label: '上课状态',
          component: 'status',
        },
        {
          prop: 'studentNum',
          label: '上课人数',
          width: 80,
        },
        {
          prop: 'startAt',
          label: '上课时间',
        },
        {
          prop: 'endAt',
          label: '下课时间',
        },
      ],
      list: [],
      count: 0,
      pagingParams: {
        page: 1,
        pageSize: 10,
      },
    }
  },
  watch: {
    filterParams: {
      deep: true,
      handler() {
        this.debounce()
      },
    },
    pagingParams: {
      deep: true,
      handler() {
        this.debounce()
      },
    },
  },
  methods: {
    ...mapActions({
      getSchedules: 'newStat/getSchedules',
      getSchoolList: 'newStat/getSchoolList',
    }),
    debounce: _.debounce(function () {
      this.getScheduleData()
    }, 300),
    async getScheduleData(noPage = false) {
      let params = {
        noPage,
      }
      if (noPage === false) {
        params = {
          ...params,
          'x-page': this.pagingParams.page,
          'x-per-page': this.pagingParams.pageSize,
        }
      }
      if (this.filterParams.status || this.filterParams.status === 0) {
        params.status = this.filterParams.status
      }
      if (this.filterParams.orgId) {
        params.orgId = this.filterParams.orgId
      }
      const res = await this.getSchedules(params)
      this.count = res.count
      const list = this.onGetList(res.rows)
      this.list = list
      return {
        count: res.count,
        rows: list,
      }
    },
    onGetList(rows) {
      const data = rows.map(row => {
        const teacher =
          (row.realityUser && row.realityUser.nickname) ||
          (row.user && row.user.username) ||
          ''
        return {
          school: row.orgInfo.orgName,
          class: row.class.name,
          area: row.orgInfo.regionFullname,
          course:
            row.course.name +
            row.sections
              .map(section => {
                return section.name
              })
              .join(' '),
          teacher: teacher,
          status: row.status,
          studentNum: row.students.length,
          startAt: moment(row.startAt).format('YYYY.MM.DD HH:mm'),
          endAt: moment(row.endAt).format('YYYY.MM.DD HH:mm'),
          orgInfo: row.orgInfo,
        }
      })
      return data
    },
    changePagingParams(paging) {
      this.pagingParams = paging
    },
    async getSchoolListFunc(val) {
      const params = {
        orgType: 0,
        isActive: false,
      }
      if (val) {
        params.name = val
      }
      const { rows } = await this.getSchoolList(params)
      return rows.map(item => {
        return {
          id: item.orgId,
          name: item.orgName,
        }
      })
    },
    async download() {
      const { rows } = await this.getScheduleData(true)
      if (rows.length > 0) {
        exportXlsx('排课列表', this.keys, rows)
      } else {
        this.$message.warning('暂时没有数据')
      }
    },
    onSortChange(params) {
      this.filterParams = {
        ...this.filterParams,
        ...params,
      }
    },
  },
}
</script>

<style lang='scss'>
</style>